import { Paper, Stack, useTheme } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { ProfileTreatmentsContent } from 'src/sections/@dashboard/profile/components/ProfileTreatments/ProfileTreatmentsContent';

export default function OrganizationPatientTabsTreatmentsPage() {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <title>Zabiegi | Vetsi</title>
      </Helmet>

      <Paper
        sx={{
          borderRadius: 2,
          boxShadow: theme.customShadows.z8,
          height: 1,
          // Paper defaults to background.paper, which is the very colour the
          // table's header row uses — on that card the header vanished into it.
          // The lighter default surface gives the header something to sit
          // against, matching the visit's own cards.
          backgroundColor: 'background.default',
        }}
      >
        <Stack sx={{ height: 1, minHeight: '560px' }}>
          <ProfileTreatmentsContent />
        </Stack>
      </Paper>
    </>
  );
}
